/**
 * 权利要求分析结果 DTO
 * Claim analysis result data structure
 */
export interface ClaimAnalysisResult {
    /** 涉及的权利要求（如 '1', '2-3', '5-6'） */
    claim_involved?: string;

    /** 审查员的对比分析 */
    examiner_comparison?: string;

    /** 核实结论 */
    verification_conclusion?: string;

    /** 对比文件公开/常识/未公开的内容分析 */
    disclosed_common_knowledge_not_disclosed?: string;

    /** 论证强度评估（强/中/弱） */
    argument_strength?: string;

    /** 推荐的应对行动 */
    recommended_action?: string;

    /** 策略建议 (Markdown 格式) */
    strategy_recommendation?: string;

    /** 论证特征（逗号分隔） */
    argument_features?: string;
}

/**
 * Request body for exportStatement API
 * 陈述书导出请求
 */
export interface RequestBody {
    /** OAR task ID (required) */
    task_id: string;

    /** 权利要求分析结果列表（由客户端调用权利要求分析服务后传入） */
    analyze_opinions_result?: ClaimAnalysisResult[];
}

/**
 * Combined request parameters
 */
export interface RequestParams {
    /** Request body */
    body: RequestBody;
}

/**
 * Response data interface
 * 陈述书导出响应
 */
export interface ResponseData {
    /** Generated file name */
    file_name: string;

    /** File download URL (pre-signed S3 URL or local path) */
    file_url: string;

    /** File size in bytes */
    file_size: number;

    /** File generation timestamp */
    timestamp: number;

    /** Content type (default: application/vnd.openxmlformats-officedocument.wordprocessingml.document) */
    content_type: string;
}

/**
 * API interface for exportStatement
 * 导出意见陈述书
 *
 * 根据OAR任务生成并导出意见陈述书Word文档，支持多个专利局格式（当前仅支持中国国知局）
 */
export interface ExportStatementApi {
    /**
   * Export statement document
   * 导出意见陈述书
   *
   * @param params - Request parameters including request body
   * @returns Promise resolving to statement export response
   */
    exportStatement(params: RequestParams): Promise<ResponseData>;
}

/**
 * Symbol for dependency injection
 */
export const ExportStatementApi = Symbol.for('ExportStatementApi');
